import React from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Glyphicon, Modal } from "react-bootstrap";

import toastr from "toastr";
import { Mode } from "./constant";
import AddFeatureModal from "./add-feautre-modal";
import { GetFeatures, AddFeature, UpdateFeature } from "./action";
import { Grid } from "../../Grid";

class FeaturesModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: Mode.NEW,
      selectedFeature: {},
      showAddFeatureModal: false,
    };

    this.onSaveFeature = this.onSaveFeature.bind(this);
    this.closeAddFeatureModal = this.closeAddFeatureModal.bind(this);
  }

  closeAddFeatureModal() {
    this.setState({
      ...this.state,
      showAddFeatureModal: false,
    });
  }

  onEdit(row) {
    this.setState({
      showAddFeatureModal: true,
      mode: Mode.EDIT,
      selectedFeature: row,
    });
  }

  async onSaveFeature(feature, mode) {
    if (mode === Mode.NEW) {
      const response = await this.props.AddFeature(feature);
      if (!response) {
        toastr.error("Error on creating feature.", "Create");
      } else if (response.payload && response.payload.error) {
        toastr.error(response.payload.error, "Create");
      } else if (response.isSuccess) {
        await this.props.GetFeatures();
        toastr.info(`Feature ${feature.feature} successfully saved.`, "Create");
        this.closeAddFeatureModal();
      }
    } else if (mode === Mode.EDIT) {
      const response = await this.props.UpdateFeature(feature);
      if (!response) {
        toastr.error("Error on updating feature.", "Update");
      } else if (response.payload && response.payload.error) {
        toastr.error(response.payload.error, "Update");
      } else if (response.isSuccess) {
        await this.props.GetFeatures();
        toastr.info(
          `Feature ${feature.feature} successfully updated.`,
          "Update"
        );
        this.closeAddFeatureModal();
      }
    }
  }

  render() {
    const columns = [
      {
        dataField: "external_feature_id",
        text: "Value",
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "description",
        text: "Description",
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "buttons",
        text: "",
        headerStyle: () => {
          return { width: "120px" };
        },
        formatter: (cell, row) => (
          <ButtonToolbar>
            <Button
              bsStyle="default"
              title="Edit Feature"
              onClick={() => this.onEdit(row)}
            >
              <Glyphicon glyph="edit" />
            </Button>
          </ButtonToolbar>
        ),
      },
    ];
    const rowStyle = { cursor: "pointer" };

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Features</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            bsStyle="primary"
            bsSize="small"
            id="btnAddNewFeature"
            onHide={this.closeNewAddFeatureModal}
            onClick={() =>
              this.setState({ showAddFeatureModal: true, mode: Mode.NEW })
            }
          >
            <Glyphicon glyph="plus" /> New Feature
          </Button>
          <Grid
            keyField="id"
            columns={columns}
            data={this.props.features}
            rowStyle={rowStyle}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-grey" onClick={this.props.onHide}>
            Close
          </button>
        </Modal.Footer>
        <AddFeatureModal
          feature={this.state.selectedFeature}
          show={this.state.showAddFeatureModal}
          onHide={this.closeAddFeatureModal}
          mode={this.state.mode}
          onSave={this.onSaveFeature}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    features: state.entitlement.features,
  };
};

export default connect(mapStateToProps, {
  GetFeatures,
  AddFeature,
  UpdateFeature,
})(FeaturesModal);
